export default __webpack_public_path__ + "media/src/assets/mooveo_logo_variant-f46ed7abe3a523f7376e1ac99244b1fb.png";